export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11886.cf69f376.jpg";